import { Button } from '@/components';
import type { ComponentProps, FC } from 'react';
import { useTranslation } from 'react-i18next';

type ButtonProps = ComponentProps<typeof Button>;

type Props = {
  onCreate?: ButtonProps['onClick'];
} & Pick<ButtonProps, 'htmlType' | 'loading' | 'disabled' | 'type'>;

export const CreateButton: FC<Props> = ({ onCreate, type, ...buttonProps }) => {
  const { t } = useTranslation();
  return (
    <Button type={type ?? 'primary'} onClick={onCreate} {...buttonProps}>
      {t('create')}
    </Button>
  );
};
